module.exports = __webpack_public_path__ + "static/media/solutions-bg.517976b8.webp";